import type { Location } from './types'

export const LOCATIONS: Location[] = [
  {
    id: 'calgary',
    city: 'Calgary',
    province: 'Alberta',
    emoji: '🏔',
    gradient: 'from-lavender-100 to-sky-400/20',
    accent: 'text-lavender-600',
    chartColor: '#8b5cf6',
    blurb: 'Mountain air & big-sky adventure',
  },
  {
    id: 'vancouver',
    city: 'Vancouver',
    province: 'British Columbia',
    emoji: '🌊',
    gradient: 'from-sky-400/20 to-teal-400/20',
    accent: 'text-sky-500',
    chartColor: '#0ea5e9',
    blurb: 'Ocean, forest & city in one',
  },
  {
    id: 'halifax',
    city: 'Halifax',
    province: 'Nova Scotia',
    emoji: '⚓',
    gradient: 'from-teal-400/20 to-lavender-100',
    accent: 'text-teal-500',
    chartColor: '#14b8a6',
    blurb: 'Historic harbour & coastal charm',
  },
  {
    id: 'toronto',
    city: 'Toronto',
    province: 'Ontario',
    emoji: '🏙',
    gradient: 'from-coral-400/20 to-lavender-100',
    accent: 'text-coral-500',
    chartColor: '#f43f5e',
    blurb: 'Skyline energy & world-class food',
  },
  {
    id: 'montreal',
    city: 'Montreal',
    province: 'Quebec',
    emoji: '🍁',
    gradient: 'from-lavender-100 to-coral-400/20',
    accent: 'text-lavender-600',
    chartColor: '#a855f7',
    blurb: 'European flair & maple magic',
  },
]

export function findLocation(city: string): Location | undefined {
  return LOCATIONS.find((l) => l.city === city)
}
